module.exports = __webpack_public_path__ + "img/noble.d22d95c7.png";